/**
 * Complete the Look (Nov 2026): prev / next arrows for the scroll-snap row in
 * blocks/complete-the-look.liquid. Replaces assets/slider-complete-the-look.js
 * (Swiper). The row itself is a native horizontal scroller, so touch, trackpad
 * and keyboard (Tab to the row, then arrow keys) work without this file; it only
 * moves the row one page per click and keeps the arrows' disabled state and the
 * [data-ctl-overflow] flag (arrows shown only when cards overflow) up to date.
 *
 * Every listener is delegated, so the block keeps working after the variant
 * picker swaps the page markup (variant-picker:updated). Loaded only by the
 * block, possibly more than once on a page: the guard below runs it once.
 */
(function () {
  if (window.kocCompleteTheLook) return;
  window.kocCompleteTheLook = true;

  /** @param {Element | null} root */
  function update(root) {
    if (!root) return;
    var track = root.querySelector('.ctl__track');
    if (!(track instanceof HTMLElement)) return;
    var max = track.scrollWidth - track.clientWidth;
    root.toggleAttribute('data-ctl-overflow', max > 1);
    var prev = root.querySelector('.ctl__nav--prev');
    var next = root.querySelector('.ctl__nav--next');
    if (prev instanceof HTMLButtonElement) prev.disabled = track.scrollLeft <= 1;
    if (next instanceof HTMLButtonElement) next.disabled = track.scrollLeft >= max - 1;
  }

  function updateAll() {
    document.querySelectorAll('.complete-the-look').forEach(update);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var button = target.closest('.ctl__nav');
    if (!button) return;
    var root = button.closest('.complete-the-look');
    var track = root && root.querySelector('.ctl__track');
    if (!(track instanceof HTMLElement)) return;

    // One page = as many whole cards as fit (at least one), so snapping lands on a card edge.
    var item = track.querySelector('.ctl__item');
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    var step = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
    var page = Math.max(1, Math.floor((track.clientWidth + gap) / step)) * step;
    var direction = button.classList.contains('ctl__nav--prev') ? -1 : 1;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({ left: direction * page, behavior: reduce ? 'auto' : 'smooth' });
  });

  // scroll does not bubble; listen in the capture phase.
  document.addEventListener(
    'scroll',
    function (event) {
      var target = event.target;
      if (target instanceof Element && target.classList.contains('ctl__track')) {
        update(target.closest('.complete-the-look'));
      }
    },
    true
  );

  window.addEventListener('resize', updateAll);
  document.addEventListener('DOMContentLoaded', updateAll);
  document.addEventListener('variant-picker:updated', updateAll);
  updateAll();
})();
